<template>
  <div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col>
          <card>
            <b-row align-v="center" slot="header">
              <b-col cols="8">
                <h3 class="mb-0">Cadastro de Peça Publicitária</h3>
              </b-col>
              <b-col cols="4" v-loading="loading" />
            </b-row>

            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <b-form @submit.prevent="handleSubmit(save)" v-loading="loading">
                <!-- Responsável pela inscrição -->
                <h6 class="heading-small text-muted mb-4">
                  Responsável pela inscrição
                </h6>
                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Nome"
                        name="Nome"
                        placeholder="Digite seu nome"
                        v-model="peca.nomeResponsavel"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="email"
                        label="E-mail"
                        name="E-mail"
                        placeholder="exemplo@email.com"
                        v-model="peca.emailResponsavel"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="4">
                      <base-input
                        type="text"
                        label="Cargo"
                        name="Cargo"
                        placeholder="Cargo na empresa"
                        v-model="peca.cargoResponsavel"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="4">
                      <base-input
                        type="text"
                        label="RG"
                        name="RG"
                        placeholder="00.000.000-0"
                        v-model="peca.rgResponsavel"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="4">
                      <base-input
                        type="text"
                        label="Celular"
                        name="Celular"
                        placeholder="(00) 0000-0000"
                        v-model="peca.celularResponsavel"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                </div>

                <hr class="my-4" />
                <!-- Profissional -->
                <h6 class="heading-small text-muted mb-4">Profissional</h6>
                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Razão Social"
                        name="Razão Social"
                        placeholder="Digite a razão social da empresa"
                        v-model="peca.razaoSocial"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Nome Fantasia"
                        name="Nome Fantasia"
                        placeholder="Digite o nome fantasia da empresa"
                        v-model="peca.nomeFantasia"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <base-input
                        type="text"
                        label="Endereço da sede"
                        name="Endereço da sede"
                        placeholder="Digite o endereço da sede da empresa"
                        v-model="peca.enderecoProfissional"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="4">
                      <base-input
                        type="text"
                        label="Cidade"
                        name="Cidade"
                        placeholder="Digite a cidade da empresa"
                        v-model="peca.cidadeProfissional"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="4">
                      <base-input
                        type="text"
                        label="Telefone"
                        name="Telefone"
                        placeholder="Digite o telefone da empresa"
                        v-model="peca.telefoneProfissional"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="4">
                      <base-input
                        type="email"
                        label="E-mail"
                        name="E-mail"
                        placeholder="Digite o e-mail da empresa"
                        v-model="peca.emailProfissional"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <base-input
                        type="text"
                        label="Coparticipação"
                        name="Coparticipação"
                        placeholder="Digite o nome da coparticipação, se houver"
                        v-model="peca.coparticipacao"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                </div>

                <hr class="my-4" />
                <!-- Equipe -->
                <h6 class="heading-small text-muted mb-4">Equipe</h6>
                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Diretor de Criação"
                        name="Diretor de Criação"
                        placeholder="Digite o nome do Diretor de Criação"
                        v-model="peca.diretorCriacao"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Diretor de Arte"
                        name="Diretor de Arte"
                        placeholder="Digite o nome do Diretor de Arte"
                        v-model="peca.diretorArte"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Redação"
                        name="Redação"
                        placeholder="Digite o nome do responsável pela Redação"
                        v-model="peca.redacao"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Atendimento"
                        name="Atendimento"
                        placeholder="Digite o nome do responsável pelo Atendimento"
                        v-model="peca.atendimento"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Planejamento"
                        name="Planejamento"
                        placeholder="Digite o nome do responsável pelo Planejamento"
                        v-model="peca.planejamento"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                </div>

                <hr class="my-4" />
                <!-- Cliente -->
                <h6 class="heading-small text-muted mb-4">Cliente</h6>
                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Nome Fantasia"
                        name="Nome Fantasia"
                        placeholder="Digite o nome fantasia do cliente"
                        v-model="peca.nomeCliente"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Nome (Contato Interno)"
                        name="Nome (Contato Interno)"
                        placeholder="Digite o nome do contato interno do cliente"
                        v-model="peca.clienteContato"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <base-input
                        type="text"
                        label="Endereço da sede"
                        name="Endereço da sede"
                        placeholder="Digite o endereço da sede do cliente"
                        v-model="peca.enderecoCliente"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Cidade"
                        name="Cidade"
                        placeholder="Digite a cidade do cliente"
                        v-model="peca.cidadeCliente"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Telefone"
                        name="Telefone"
                        placeholder="Digite o telefone do cliente"
                        v-model="peca.telefoneCliente"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                </div>

                <hr class="my-4" />
                <!-- Fornecedores -->
                <h6 class="heading-small text-muted mb-4">Fornecedores</h6>
                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Gráfica"
                        name="Gráfica"
                        placeholder="Digite o nome da gráfica"
                        v-model="peca.grafica"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Fotógrafo"
                        name="Fotógrafo"
                        placeholder="Digite o nome do fotógrafo"
                        v-model="peca.fotografo"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Produtora de TV"
                        name="Produtora de TV"
                        placeholder="Digite o nome da produtora de TV"
                        v-model="peca.produtoraTv"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Produtora de Áudio"
                        name="Produtora de Áudio"
                        placeholder="Digite o nome da produtora de áudio"
                        v-model="peca.produtoraAudio"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <base-input
                        type="text"
                        label="Outros"
                        name="Outros"
                        placeholder="Digite o nome de outros fornecedores"
                        v-model="peca.outros"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                </div>

                <hr class="my-4" />
                <!-- Dados da peça -->
                <h6 class="heading-small text-muted mb-4">Dados da peça</h6>
                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Título da peça"
                        name="Título da peça"
                        placeholder="Digite o título da peça"
                        v-model="peca.pecaTitulo"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <div class="form-group">
                        <validation-provider
                          :rules="{ required: true }"
                          name="Categoria"
                          v-slot="{ errors }"
                        >
                          <label class="form-control-label">Categoria</label>
                          <b-form-select
                            class="shadow-none"
                            v-model="peca.idCategoriaPecaPublicitaria"
                            name="Categoria"
                            :options="categorias"
                            :state="errors[0] ? false : null"
                          />

                          <slot name="error">
                            <div
                              v-if="errors[0]"
                              class="invalid-feedback"
                              style="display: block"
                            >
                              {{ errors[0] }}
                            </div>
                          </slot>
                        </validation-provider>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="date"
                        label="Data de início da veiculação"
                        name="Data de início da veiculação"
                        placeholder="Digite a data de início da veiculação"
                        v-model="peca.dataInicioVeiculacao"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="date"
                        label="Data de término da veiculação"
                        name="Data de término da veiculação"
                        placeholder="Digite a data de término da veiculação"
                        v-model="peca.dataFimVeiculacao"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <div class="form-group">
                        <label class="form-control-label">
                          Resumo sobre o conceito, planejamento e criação
                        </label>
                        <b-form-textarea
                          id="resumo"
                          name="Resumo"
                          v-model="peca.conceito"
                          placeholder="Digite um resumo sobre a peça..."
                          rows="5"
                          max-rows="8"
                        ></b-form-textarea>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <base-input
                        type="text"
                        label="URL: (Link não pode fazer menção a agência)"
                        name="URL"
                        placeholder="https://"
                        v-model="peca.url"
                      >
                      </base-input>
                    </b-col>
                  </b-row>

                  <div v-if="!idEdit" id="upload-arquivos">
                    <b-row>
                      <b-col lg="12">
                        <validation-provider
                          rules="size:10240"
                          name="Peça"
                          v-slot="{ validate, errors }"
                        >
                          <label class="form-control-label">Peça</label>
                          <b-form-file
                            v-model="fileUpload1"
                            placeholder="Escolha um arquivo ou arraste ele aqui..."
                            browse-text="Escolher arquivo"
                            drop-placeholder="Arraste o arquivo aqui..."
                            @change="validate"
                            :state="errors[0] ? false : null"
                          ></b-form-file>
                          <slot name="error">
                            <div
                              v-if="errors[0]"
                              class="invalid-feedback"
                              style="display: block"
                            >
                              {{ errors[0] }}
                            </div>
                          </slot>
                        </validation-provider>
                        <div class="text-muted mt-1">
                          Tipo de arquivo permitido: PDF - Tamanho máximo: 10MB
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4">
                      <b-col lg="6">
                        <validation-provider
                          rules="required|size:10240"
                          name="Pedido de Inserção"
                          v-slot="{ validate, errors }"
                        >
                          <label class="form-control-label"
                            >Pedido de Inserção</label
                          >
                          <b-form-file
                            v-model="fileUpload2"
                            placeholder="Escolha um arquivo ou arraste ele aqui..."
                            browse-text="Escolher arquivo"
                            drop-placeholder="Arraste o arquivo aqui..."
                            @change="validate"
                            :state="errors[0] ? false : null"
                          ></b-form-file>

                          <slot name="error">
                            <div
                              v-if="errors[0]"
                              class="invalid-feedback"
                              style="display: block"
                            >
                              {{ errors[0] }}
                            </div>
                          </slot>
                        </validation-provider>
                      </b-col>
                      <b-col lg="6">
                        <validation-provider
                          rules="required|size:10240"
                          name="Comprovante de Pagamento"
                          v-slot="{ validate, errors }"
                        >
                          <label class="form-control-label"
                            >Comprovante de Pagamento</label
                          >
                          <b-form-file
                            v-model="fileUpload3"
                            placeholder="Escolha um arquivo ou arraste ele aqui..."
                            browse-text="Escolher arquivo"
                            drop-placeholder="Arraste o arquivo aqui..."
                            @change="validate"
                            :state="errors[0] ? false : null"
                          ></b-form-file>

                          <slot name="error">
                            <div
                              v-if="errors[0]"
                              class="invalid-feedback"
                              style="display: block"
                            >
                              {{ errors[0] }}
                            </div>
                          </slot>
                        </validation-provider>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-else id="visualizar-arquivos">
                    <b-row>
                      <b-col lg="12">
                        <div class="form-group">
                          <label class="form-control-label">Peça</label>
                          <div>
                            <a
                              :href="
                                '/uploads/' +
                                DEPLOYED_YEAR +
                                '/' +
                                peca.arquivo1
                              "
                              class="btn btn-sm btn-info"
                              target="_blank"
                              v-if="peca.arquivo1"
                            >
                              Ver Peça
                            </a>
                            <span
                              class="form-control-label text-muted font-weight-normal"
                              v-else
                              >(Vazio)</span
                            >
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="6">
                        <div class="form-group">
                          <label class="form-control-label"
                            >Pedido de Inserção</label
                          >
                          <div>
                            <a
                              :href="
                                '/uploads/' +
                                DEPLOYED_YEAR +
                                '/' +
                                peca.arquivo2
                              "
                              class="btn btn-sm btn-info"
                              target="_blank"
                              v-if="peca.arquivo2"
                            >
                              Ver Pedido de Inserção
                            </a>
                            <span
                              class="form-control-label text-muted font-weight-normal"
                              v-else
                              >(Vazio)</span
                            >
                          </div>
                        </div>
                      </b-col>
                      <b-col lg="6">
                        <div class="form-group">
                          <label class="form-control-label"
                            >Comprovante de Pagamento</label
                          >

                          <div>
                            <a
                              :href="
                                '/uploads/' +
                                DEPLOYED_YEAR +
                                '/' +
                                peca.arquivo3
                              "
                              class="btn btn-sm btn-info"
                              target="_blank"
                              v-if="peca.arquivo3"
                            >
                              Ver Comprovante de Pagamento
                            </a>
                            <span
                              class="form-control-label text-muted font-weight-normal"
                              v-else
                              >(Vazio)</span
                            >
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>

                <hr class="my-4" />
                <div
                  class="pl-lg-4 d-flex justify-content-end align-items-center"
                >
                  <span class="text-danger mr-3">{{ errorFeedback }}</span>
                  <base-button
                    type="primary"
                    native-type="submit"
                    :loading="loading"
                    class="my-4"
                  >
                    <span v-if="!idEdit">Cadastrar</span>
                    <span v-else>Salvar</span>
                  </base-button>
                </div>
              </b-form>
            </validation-observer>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import api, { getRequestErrorMessage } from "@/services/api";
import { parse, format } from "date-fns";
import { DEPLOYED_YEAR } from "@/util/constants";

export default {
  data() {
    return {
      DEPLOYED_YEAR,
      errorFeedback: "",
      loading: false,
      idEdit: null,
      categorias: [],
      fileUpload1: null,
      fileUpload2: null,
      fileUpload3: null,
      peca: {
        id: "",
        arquivo1: null,
        arquivo2: null,
        arquivo3: null,
        idCategoriaPecaPublicitaria: null,
        atendimento: "",
        cargoResponsavel: "",
        celularResponsavel: "",
        cidadeCliente: "",
        cidadeProfissional: "",
        cliente: "",
        clienteContato: "",
        conceito: "",
        coparticipacao: "",
        dataFimVeiculacao: "",
        dataInicioVeiculacao: "",
        diretorArte: "",
        diretorCriacao: "",
        emailProfissional: "",
        emailResponsavel: "",
        enderecoCliente: "",
        enderecoProfissional: "",
        fotografo: "",
        grafica: "",
        nomeCliente: "",
        nomeFantasia: "",
        nomeResponsavel: "",
        outros: "",
        pecaTitulo: "",
        planejamento: "",
        produtoraAudio: "",
        produtoraTv: "",
        razaoSocial: "",
        redacao: "",
        rgResponsavel: "",
        telefoneCliente: "",
        telefoneProfissional: "",
        tituloPeca: "",
        url: "",
        idPublicitario: "",
      },
    };
  },
  methods: {
    async save() {
      this.errorFeedback = "";
      this.loading = true;
      if (!this.idEdit) {
        await this.saveAllFiles();
      }
      try {
        const processedPeca = Object.assign({}, this.peca);
        processedPeca.dataInicioVeiculacao = this.formatDateToISO(
          this.peca.dataInicioVeiculacao
        );
        processedPeca.dataFimVeiculacao = this.formatDateToISO(
          this.peca.dataFimVeiculacao
        );

        await api.post("/peca-publicitaria", processedPeca);
        this.$router.push("/usuario");
      } catch (e) {
        console.error(e);
        this.throwError();
      } finally {
        this.loading = false;
      }
    },
    formatDateToISO(strDate) {
      if (strDate) {
        const date = parse(strDate, "yyyy-MM-dd", new Date());
        //const dtDateOnly = new Date(date.valueOf() - date.getTimezoneOffset() * 60 * 1000);
        return date.toISOString();
      } else {
        return null;
      }
    },
    formatISOToDate(strDate) {
      if (strDate) {
        return format(new Date(strDate), "yyyy-MM-dd");
      } else {
        return null;
      }
    },
    async saveFile(file) {
      if (file) {
        const dataForm = new FormData();
        dataForm.append("file", file);
        try {
          const response = await api.post("/file/upload", dataForm);
          if (
            response.data.filesUploaded &&
            response.data.filesUploaded.length > 0
          ) {
            return response.data.filesUploaded[0];
          } else {
            this.loading = false;
            this.throwError("Ocorreu um problema ao subir os arquivos.");
            throw new Error("Ocorreu um problema ao subir os arquivos.");
          }
        } catch (e) {
          this.loading = false;
          const msg = getRequestErrorMessage(
            e,
            "Ocorreu um problema ao subir os arquivos."
          );
          this.throwError(msg);
          throw new Error(msg);
        }
      } else {
        return "";
      }
    },
    async saveAllFiles() {
      try {
        let p1 = Promise.resolve();
        let p2 = Promise.resolve();
        let p3 = Promise.resolve();
        if (this.fileUpload1) {
          p1 = this.saveFile(this.fileUpload1).then((fileName) => {
            this.peca.arquivo1 = fileName;
          });
        }
        if (this.fileUpload2) {
          p2 = this.saveFile(this.fileUpload2).then((fileName) => {
            this.peca.arquivo2 = fileName;
          });
        }
        if (this.fileUpload3) {
          p3 = this.saveFile(this.fileUpload3).then((fileName) => {
            this.peca.arquivo3 = fileName;
          });
        }
        return Promise.all([p1, p2, p3]);
      } catch (e) {
        console.error(e);
        this.loading = false;
        this.throwError(
          getRequestErrorMessage(e, "Ocorreu um problema ao subir os arquivos.")
        );
        return Promise.reject(e);
      }
    },
    throwError(msg) {
      this.errorFeedback =
        msg || "Ocorreu um problema. Por favor, tente novamente mais tarde.";
    },
    async loadCategorias() {
      const response = await api.get("/categoria-peca-publicitaria");
      const categoriasFiltered = response.data.data
        .filter((cat) => cat.ativo)
        .sort((a, b) => a.posicao - b.posicao);

      const categorias = categoriasFiltered.map((cat) => ({
        value: cat.id,
        text: cat.nome,
      }));
      categorias.unshift({ value: null, text: "Selecione uma categoria..." });

      this.categorias = categorias;
    },
  },
  async mounted() {
    this.idEdit = this.$route.params.id;

    if (this.idEdit) {
      this.loading = true;
      await this.loadCategorias();
      try {
        const response = await api.get(`/peca-publicitaria/${this.idEdit}`);
        const peca = response.data;

        peca.dataInicioVeiculacao = this.formatISOToDate(
          peca.dataInicioVeiculacao
        );
        peca.dataFimVeiculacao = this.formatISOToDate(peca.dataFimVeiculacao);

        this.peca = peca;
      } catch (e) {
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao carregar os dados. Por favor, tente novamente mais tarde."
        );
      } finally {
        this.loading = false;
      }
    } else {
      const { details } = JSON.parse(localStorage.getItem("user@mf"));

      if (details.id) {
        this.peca.idPublicitario = details.id;

        this.peca.nomeResponsavel = details.nomeResponsavel;
        this.peca.emailResponsavel = details.emailResponsavel;
        this.peca.cargoResponsavel = details.cargoResponsavel;
        this.peca.rgResponsavel = details.rgResponsavel;
        this.peca.celularResponsavel = details.celularResponsavel;
        this.peca.razaoSocial = details.razaoSocial;
        this.peca.nomeFantasia = details.nomeFantasia;
        this.peca.enderecoProfissional = details.enderecoProfissional;
        this.peca.cidadeProfissional = details.cidadeProfissional;
        this.peca.telefoneProfissional = details.telefoneProfissional;
        this.peca.emailProfissional = details.emailProfissional;
        this.peca.diretorCriacao = details.diretorCriacao;
        this.peca.diretorArte = details.diretorArte;
        this.peca.redacao = details.redacao;
        this.peca.atendimento = details.atendimento;
        this.peca.planejamento = details.planejamento;
      }

      this.loadCategorias();
    }
  },
};
</script>
<style></style>
